module.exports = __webpack_public_path__ + "img/3f2b51e6a7052aee024de54059524f58.png";